// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductActions from "@sc/App/Components/Product/ProductActions";
import BreakPricing from "@sc/XDL/Icons/BreakPricing";
import { color, createLinkIconStyles } from "@sc/XDL/Utilities";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({});

export interface ProductDetailsActionsStyles {
    wrapper?: InjectableCss;
    separator?: InjectableCss;
    breakPricingLink?: LinkPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
}

export const productDetailsActionsStyles: ProductDetailsActionsStyles = {
    wrapper: {
        css: css`
            padding: 13px;
            border-radius: 4px;
            border: 1px solid ${color("common.border")};
        `,
    },
    separator: {
        css: css`
            width: 100%;
            height: 1px;
            border-top: 1px solid ${color("common.border")};
            margin: 12px 0;
        `,
    },
};

const styles = productDetailsActionsStyles;

const ProductDetailsActions: React.FC<Props> = ({ product }) => {
    if (!product) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            {createWidgetElement("ProductDetails/ProductDetailsPrice", {
                fields: {},
            })}
            {createWidgetElement("ProductDetails/ProductDetailsAvailability", {
                fields: {},
            })}
            <StyledWrapper {...styles.separator} />
            <ProductQuantityBreakPricing extendedStyles={styles.productQuantityBreakPricingStyles} />
            <ProductActions />
            {createWidgetElement("ProductDetails/ProductDetailsAddToListLink", {
                fields: {},
            })}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsActions)),
    definition: {
        displayName: "Product Actions",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
